/**
 * External dependencies
 */
import Splide from '@splidejs/splide';

/**
 * Internal dependencies
 */
import './index.scss';

document.addEventListener( 'DOMContentLoaded', function() {
	const initEvent = new CustomEvent( 'splideReady', { detail: Splide } );
	document.dispatchEvent( initEvent );

	const elms = document.querySelectorAll( '.wp-block-photobooths-carousel > .splide' );

	for ( let i = 0; i < elms.length; i++ ) {
		const splideData = elms[ i ].getAttribute( 'data-splide' );

		const linkedSlides = elms[ i ].querySelectorAll( '.splide__slide[data-link]' );
		linkedSlides.forEach( ( slide ) => {
			try {
				const linkData = JSON.parse( slide.getAttribute( 'data-link' ) );
				const slideLink = document.createElement( 'a' );
				slideLink.classList.add( 'splide__slide-link' );
				slideLink.setAttribute( 'href', linkData.url );
				slideLink.setAttribute( 'target', linkData.target ?? '_self' );
				slideLink.setAttribute( 'rel', linkData.rel ?? 'noopener' );
				slideLink.setAttribute( 'aria-hidden', 'true' );

				slide.prepend( slideLink );
			} catch ( e ) {
				// Do nothing
			} finally {
				slide.removeAttribute( 'data-link' );
			}
		} );

		// If empty Splide args remove the attribute
		if ( '' === splideData ) {
			elms[ i ].removeAttribute( 'data-splide' );
		}

		// Set defaults.
		Splide.defaults = {
			... Splide.defaults,
			...{
				type: 'loop',
				perPage: 4,
				gap: '36px',
				arrows: true,
				pagination: false,
				perMove: 1,
				breakpoints: {
					959: {
						perPage: 3,
					},
					781: {
						perPage: 2,
					},
					599: {
						perPage: 1,
					},
				},
			},
		};

		const splide = new Splide( elms[ i ] );

		splide.on( 'mounted', function() {
			const mountedEvent = new CustomEvent( 'mounted', {
				detail: splide,
			} );
			elms[ i ].dispatchEvent( mountedEvent );
		} );

		if ( splide.root.id ) {
			// Append "Carousel" to ID if not present
			if ( ! splide.root.id.substr( -8 ).includes( 'Carousel' ) ) {
				splide.root.id += 'Carousel';
			}

			window[ splide.root.id ] = splide;
		}

		splide.mount();
	}
} );
